import reducer from "./reducer";
import actionNames from "./actions";
export * from "./actions";
export default {
  reducer,
  actionNames,
};
